import TRow from './TRow';
interface IProps {
  data: any;
  isView: any;
  handleChangeRow: any;
  handelDeleteRows: (rowIdx: number) => void;
  openModal: any;
  removePart: any;
  handleModalForLocation: any;
}
const IsComplete = (process: any) => {
  let totalRejectionQty = process?.reasons_for_rej?.reduce(
    (sum: number, item: any) => sum + +item.rej_qty,
    0
  );
  totalRejectionQty += process?.reasons_for_less_prod?.reduce(
    (sum: number, item: any) => sum + +item.rej_qty,
    0
  );
  const ngQty = process.prod_qty - process.accepted_qty;
  if (ngQty - totalRejectionQty === 0) return true;
  return false;
};

const TBody = ({
  data,
  isView,
  handleChangeRow,
  handelDeleteRows,
  openModal,
  removePart,
  handleModalForLocation,
}: IProps) => {
  const { isReportLocked } = data?.head;

  return (
    <>
      <tbody>
        {data &&
          data?.processes?.map((rowData: any, index: number) => (
            <TRow
              {...{
                index,
                openModal,
                removePart,
                rowData,
                isView,
                handleChangeRow,
                handelDeleteRows,
                handleModalForLocation,
                isReportLocked,
              }}
              key={index}
            />
          ))}
      </tbody>
    </>
  );
};

export default TBody;
